// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eb1b8a97","455":"55330d7d"}[chunkId] + ".chunk.js";
};